import { Box, HStack, Tag, Text } from '@chakra-ui/react';
import { GlobalSearchConceptItem } from '@texas/api/endpoints/search/searchApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { useTranslation } from 'react-i18next';

interface Props {
  concept: GlobalSearchConceptItem;
  onResultClick: () => void;
}

export function ConceptItem({ concept, onResultClick }: Props) {
  const { t } = useTranslation();

  return (
    <AngularNavLink
      to="concept"
      navobj={{ customerId: concept.customerId, conceptId: concept.id }}
      onClick={onResultClick}
      p={2}
      borderRadius="md"
      _hover={{
        bg: 'whiteAlpha.100',
        _light: { bg: 'blackAlpha.100' },
      }}
      textDecoration="none"
    >
      <Box>
        <HStack>
          <Text fontWeight="bold">{concept.name}</Text>
          {concept.archived && (
            <Tag size="sm" colorScheme="orange">
              {t('general.archived')}
            </Tag>
          )}
        </HStack>
        <Text fontSize="sm">{concept.customerName}</Text>
      </Box>
    </AngularNavLink>
  );
}
